import { Card } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

function Block({
  width,
  height,
  className = ''
}: {
  width: number | string;
  height: number;
  className?: string;
}) {
  const isPx = typeof width === 'number';

  return (
    <span className={`d-block ${className}`.trim()}>
      <TextLoading width={width} height={height} isWidthPx={isPx} />
    </span>
  );
}

function ComparisonChartPreload() {
  return (
    <Card className="h-100 border shadow-sm">
      <Card.Header className="bg-body-tertiary">
        <Block width="42%" height={14} className="mb-2" />
        <Block width="70%" height={10} />
      </Card.Header>
      <Card.Body>
        <div className="d-flex align-items-end justify-content-around gap-3" style={{ height: 220 }}>
          {[45, 78, 58, 92, 66].map((height, index) => (
            <Block key={index} width="12%" height={height} />
          ))}
        </div>
        <div className="d-flex justify-content-around gap-3 mt-3">
          {[1, 2, 3, 4, 5].map(index => (
            <Block key={index} width="14%" height={10} />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

/** Skeleton for the analysis comparison result page. */
export default function ComparisonPreload() {
  return (
    <div className="pb-4" aria-hidden>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
        <div>
          <Block width={170} height={18} className="mb-2" />
          <Block width={240} height={10} />
        </div>
        <Block width={110} height={30} />
      </div>

      <div className="row g-3 mb-4">
        {[1, 2, 3].map(index => (
          <div className="col-12 col-lg-4" key={index}>
            <Card className="h-100 border shadow-sm">
              <Card.Body>
                <Block width="70%" height={12} className="mb-4" />
                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <Block width={70} height={26} className="mb-2" />
                    <Block width={75} height={10} />
                  </div>
                  <div>
                    <Block width={92} height={10} className="mb-2" />
                    <Block width={82} height={10} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>

      <div className="row g-3 mb-4">
        <div className="col-12 col-xl-6">
          <ComparisonChartPreload />
        </div>
        <div className="col-12 col-xl-6">
          <ComparisonChartPreload />
        </div>
      </div>

      <Block width={130} height={14} className="mb-3" />
      {[1, 2].map(section => (
        <div key={section} className="mb-4">
          <Block width={180} height={14} className="mb-2" />
          <Block width={260} height={10} className="mb-3" />
          <Card className="border shadow-sm">
            <Card.Body className="p-2">
              {Array.from({ length: 6 }, (_, row) => (
                <div
                  key={row}
                  className="d-flex align-items-center gap-3 border-bottom py-3"
                >
                  {[32, 28, 28].map((width, column) => (
                    <Block key={column} width={`${width}%`} height={12} />
                  ))}
                </div>
              ))}
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  );
}
